import React from 'react'
import { FormattedMessage } from 'react-intl'

export const VEHICLE_TO_COMPARE_TOOLTIP = {
    id: 'vehicle_add_to_compare.tooltip.id',
    message: (
        <FormattedMessage
            id='vehicle_add_to_compare.tooltip.message'
            defaultMessage='Добавить к сравнению'
        />
    ),
}



// WEBPACK FOOTER //
// ./components/VehicleAddToComparison/constants.jsx